import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { SettingsModule } from '@/store/modules/settings';
import ThemePicker from '@/components/ThemePicker/index.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "fixedHeader",
    get: function get() {
      return SettingsModule.fixedHeader;
    },
    set: function set(value) {
      SettingsModule.ChangeSetting({
        key: 'fixedHeader',
        value: value
      });
    }
  }, {
    key: "showTagsView",
    get: function get() {
      return SettingsModule.showTagsView;
    },
    set: function set(value) {
      SettingsModule.ChangeSetting({
        key: 'showTagsView',
        value: value
      });
    }
  }, {
    key: "showSidebarLogo",
    get: function get() {
      return SettingsModule.showSidebarLogo;
    },
    set: function set(value) {
      SettingsModule.ChangeSetting({
        key: 'showSidebarLogo',
        value: value
      });
    }
  }, {
    key: "sidebarTextTheme",
    get: function get() {
      return SettingsModule.sidebarTextTheme;
    },
    set: function set(value) {
      SettingsModule.ChangeSetting({
        key: 'sidebarTextTheme',
        value: value
      });
    }
  }, {
    key: "themeChange",
    value: function themeChange(value) {
      SettingsModule.ChangeSetting({
        key: 'theme',
        value: value
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'Settings',
  components: {
    ThemePicker: ThemePicker
  }
})], default_1);
export default default_1;